export default __webpack_public_path__ + "static/media/AvatarFilip.5f94fb56.svg";